var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadgeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496.158 496.158",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5AA17"
    },
    d: "M0,248.085C0,111.063,111.069,0.003,248.075,0.003c137.013,0,248.083,111.061,248.083,248.082 c0,137.002-111.07,248.07-248.083,248.07C111.069,496.155,0,385.087,0,248.085z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M337.844,111.335c0-15.279-179.877-15.279-179.877,0c0,0,0,20.006,0,21.303 c0,51.568,40.267,93.367,89.931,93.367c49.676,0,89.946-41.799,89.946-93.367C337.844,131.341,337.844,111.335,337.844,111.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.26,327.179c0,11.005-39.834,11.005-39.834,0l-12.69-109.775c0-11.006,65.224-11.006,65.224,0 L268.26,327.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.648,334.162c-6.029-11.821-34.167-14.995-68.37-15.019v-0.002c-0.067,0-0.133,0-0.199,0 s-0.132,0-0.199,0v0.002c-34.203,0.023-62.341,3.197-68.37,15.019c-6.054,11.867-3.828,61.536-3.828,62.12h72.198h0.398h72.198 C320.476,395.698,322.702,346.029,316.648,334.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M324.141,221.253c-16.809,0.002-30.356-12.514-30.993-13.11c-2.464-2.313-2.588-6.186-0.275-8.649 c2.314-2.465,6.187-2.587,8.65-0.275c0.119,0.109,13.23,12.092,26.641,9.402c8.607-1.729,16.014-9.295,22.013-22.492 c6.271-13.793,7.206-24.722,2.783-32.48c-6.206-10.889-21.64-12.848-21.793-12.865c-3.36-0.363-5.788-3.383-5.424-6.742 c0.364-3.36,3.39-5.794,6.743-5.424c0.883,0.096,21.736,2.533,31.106,18.971c6.478,11.363,5.712,26.035-2.274,43.605 c-7.737,17.021-18.111,26.929-30.834,29.445C328.333,221.062,326.21,221.253,324.141,221.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M172.017,221.253c16.809,0.002,30.356-12.514,30.993-13.11c2.464-2.313,2.588-6.186,0.275-8.649 c-2.314-2.465-6.188-2.587-8.65-0.275c-0.119,0.109-13.23,12.092-26.641,9.402c-8.607-1.729-16.014-9.295-22.014-22.492 c-6.27-13.793-7.205-24.722-2.782-32.48c6.206-10.889,21.64-12.848,21.793-12.865c3.36-0.363,5.788-3.383,5.424-6.742 c-0.364-3.36-3.39-5.794-6.743-5.424c-0.883,0.096-21.736,2.533-31.106,18.971c-6.478,11.363-5.712,26.035,2.274,43.605 c7.737,17.021,18.111,26.929,30.834,29.445C167.825,221.062,169.948,221.253,172.017,221.253z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIcon);
export default __webpack_public_path__ + "static/media/BadgeIcon.f951a2b21ccc187b5544d588c0918718.svg";
export { ForwardRef as ReactComponent };